import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { ConfigService } from '../../providers/config';
import { ErrorHandling } from '../../shared/error.handling';
import { AppTheme } from '../../apptheme/apptheme';
import { Events } from 'ionic-angular';
import {UserService} from "../../providers/user";

@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html'
})
export class SettingsPage {

    offsetCounter: number;
    useglobalsearch: boolean = false;
    uselastsearchqueries: boolean = false;
    config: any = {};
    searchLevel1: boolean = true;
    apptheme: boolean = false;
    licensekey: string = '-';
    licensename: string = '-';
    currentuser: string = '-';

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public errorHandling: ErrorHandling,
                public configService: ConfigService,
                public appThemes: AppTheme,
                public events: Events,
                public userService: UserService) {

        this.config = this.configService.getConfig();
        let useglobalsearch = localStorage.getItem('useglobalsearch');

        if (useglobalsearch) {
            if (JSON.parse(useglobalsearch) == '0') {
                this.useglobalsearch = false;
            } else if (JSON.parse(useglobalsearch) == '1') {
                this.useglobalsearch = true;
            }
        }

        let uselastsearchqueries = localStorage.getItem('uselastsearchqueries');

        if (uselastsearchqueries) {
            if (JSON.parse(uselastsearchqueries) == '0') {
                this.uselastsearchqueries = false;
            } else if (JSON.parse(uselastsearchqueries) == '1') {
                this.uselastsearchqueries = true;
            }
        }

        let searchLevel1 = localStorage.getItem('settings.searchLevel1');
        if (searchLevel1) {
            if (JSON.parse(searchLevel1) == '1') {
                this.searchLevel1 = true;
            } else if (JSON.parse(searchLevel1) == '0') {
                this.searchLevel1 = false;
            }
        }

        let apptheme = localStorage.getItem('settings.apptheme');
        if (apptheme) {
            if (JSON.parse(apptheme) == '1') {
                this.apptheme = true;
            } else if (JSON.parse(apptheme) == '0') {
                this.apptheme = false;
            }
        }
    }

    setSearchLevel1(e) {
        if (e) {
            localStorage.setItem('settings.searchLevel1', '1');
        } else {
            localStorage.setItem('settings.searchLevel1', '0');
        }
    }

    setAppTheme(e) {
        let loader = this.loadingCtrl.create({});

        // theme klasse aus body-tag entfernen
        let themeObj = Object.keys(this.appThemes.themeClass);
        for (let i = 0; i < themeObj.length; i++) {
            document.body.classList.remove(this.appThemes.themeClass[i]);
        }

        if (e) {
            localStorage.setItem('settings.apptheme', '1');
            // theme klasse zu body-tag hinzufügen
            document.body.classList.add(this.appThemes.themeClass[1]);
        } else {
            localStorage.setItem('settings.apptheme', '0');
            // theme klasse zu body-tag hinzufügen
            document.body.classList.add(this.appThemes.themeClass[0]);
        }

        let alert = this.alertCtrl.create({
            title: 'Hinweis',
            subTitle: 'Die Anwendung muss neu geladen werden, um die Konfiguration zu übernehmen.',
            enableBackdropDismiss: false,
            buttons: [{
                text: 'Ok',
                handler: () => {
                    // loader.present();
                    // setTimeout(() => {
                    //     this.events.publish('theme:update', e, Date.now())
                    //     this.navCtrl.setRoot(SettingsPage);
                    //     loader.dismiss();
                    //     location.reload();
                    // }, 1000);
                    location.reload();
                    }
                }]
        });
        alert.present();
    }

    /**
     * Toggles global search functionality
     * @param e
     */
    setGlobalSearch(e) {
        if (e === false) {
            localStorage.setItem('useglobalsearch', '0');
            //Reset search category when global search is toggled off
            if (localStorage.getItem('storedSearchCategory') === 'Global') {
                localStorage.setItem('storedSearchCategory', 'Structure');
            }
        } else {
            localStorage.setItem('useglobalsearch', '1');
        }
    }

    /**
     * Sets las search query to localStorage
     * @param e
     */
    setLastSearchQueries(e) {
        if (e === false) {
            localStorage.setItem('uselastsearchqueries', '0');
        } else {
            localStorage.setItem('uselastsearchqueries', '1');
        }
    }

    /**
     * Parses offset counter
     */
    ionViewDidLoad() {
        this.offsetCounter = parseInt(localStorage.getItem('settings.offsetCounter'));
    }

    ionViewWillEnter(){
        // get Conditions for licencekey and -name
        this.getConditions();
    }

    /**
     * Sets offset counter
     */
    setOffsetCounter() {
        localStorage.setItem('settings.offsetCounter', '' + this.offsetCounter);
    }

    /**
     * Deletes the saved favorites from localStorage
     */
    deleteFavoritesFromLocalStorage() {
        let alert = this.alertCtrl.create({
            title: 'Favoriten löschen',
            message: 'Möchten Sie wirklich Ihre Favoriten löschen?',
            buttons: [
                {
                    text: 'Abbrechen'
                },
                {
                    text: 'Ok',
                    handler: () => {
                        localStorage.setItem('favorites', JSON.stringify([]));
                    }
                }
            ]
        });
        alert.present();
    }

    getConditions(){

        return this.userService.checkValidToken().subscribe(
            (response) => {
                console.log('getConditions -> this.userService.checkValidToken: ', response.results);
                this.licensekey = response.results.Licence.Key;
                this.licensename = response.results.Licence.Name;
                this.currentuser = response.results.User.Name;

            },
            (error) => {
                console.log('getConditions -> settings -> error', error);
            }
        )

    }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts